import { fetchChannelInstanceQuery } from '../_internal/queries/channel-instance.queries';
import { useQuery } from 'data-fetching-client';
export const useChannelInstanceByChannelId = channelInstanceId => {
  const {
    data,
    error,
    loading
  } = useQuery(fetchChannelInstanceQuery, {
    variables: {
      channelInstanceId
    }
  });
  return {
    channelInstance: data === null || data === void 0 ? void 0 : data.channelInstance,
    error,
    loading
  };
};